var _circle, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPopupHead(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#E7ECFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 35.5C17 34.1739 17.5268 32.9021 18.4645 31.9645C19.4021 31.0268 20.6739 30.5 22 30.5H32C33.3261 30.5 34.5979 31.0268 35.5355 31.9645C36.4732 32.9021 37 34.1739 37 35.5C37 36.163 36.7366 36.7989 36.2678 37.2678C35.7989 37.7366 35.163 38 34.5 38H19.5C18.837 38 18.2011 37.7366 17.7322 37.2678C17.2634 36.7989 17 36.163 17 35.5Z",
    stroke: "#A3AED0",
    strokeWidth: 1.8125,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 25.5C29.0711 25.5 30.75 23.8211 30.75 21.75C30.75 19.6789 29.0711 18 27 18C24.9289 18 23.25 19.6789 23.25 21.75C23.25 23.8211 24.9289 25.5 27 25.5Z",
    stroke: "#A3AED0",
    strokeWidth: 1.8125
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.834 38.3751V37.1667C16.834 33.1672 20.0844 29.9167 24.084 29.9167H28.9173C32.9169 29.9167 36.1673 33.1672 36.1673 37.1667V38.3751",
    stroke: "#A3AED0",
    strokeWidth: 2.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "33.83 33.83"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5013 26.2917C23.8309 26.2917 21.668 24.1288 21.668 21.4583C21.668 18.7879 23.8309 16.625 26.5013 16.625C29.1717 16.625 31.3346 18.7879 31.3346 21.4583C31.3346 24.1288 29.1717 26.2917 26.5013 26.2917Z",
    stroke: "#A3AED0",
    strokeWidth: 2.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "33.83 33.83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupHead);
export default __webpack_public_path__ + "static/media/popup-head.043618e80fc9fac7eef0a9807b145f72.svg";
export { ForwardRef as ReactComponent };